import * as React from "react";
import { Container, Navbar, Nav, Image } from "react-bootstrap";
import { DeveloperUserNavigation } from "src/components/developer";
import logo from "src/assets/images/logos/preveil-logo.png";

type AllProps = {
  active_path?: string;
}

function TopNavigationComponent(props: AllProps) {
  const { active_path } = props;

  return <header id="preveil-header">
    <Navbar variant="dark" expand="md" fixed="top"  >
      <Container fluid>
        <Navbar.Brand href="/">
          <span className="d-none">PreVeil</span>
          <Image alt="PreVeil Logo" src={logo} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="top-navbar" />
        <Navbar.Collapse id="top-navbar" >
          <Nav className="user-nav hide-mobile">
            <DeveloperUserNavigation active_path={active_path}/>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  </header>;
}

export default React.memo(TopNavigationComponent);
